<template>
  <require from="framework/html_behaviors/af-measure"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-lookup"></require>
  <require from="controls/bs-form-select"></require>
  <require from="controls/bs-form-switch"></require>
  <require from="framework/value_converters/latlng"></require>

  <div class="form-row" af-measure.bind="[{ property: 'scrollWidth', to: 460, class: 'row-cols-1' }, { property: 'scrollWidth', from: 460, to: 1120, class: 'row-cols-3' }, { property: 'scrollWidth', from: 1120, class: 'row-cols-5' }]">
    <div class="col">
      <bs-form-lookup label="User" placeholder="Enter name or email" value.bind="model.text" item.bind="model.user" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html"></bs-form-lookup>
    </div>
    <div class="col">
      <bs-form-select label="Country" placeholder="Please select" value.bind="model.country" options.bind="keywords.countries" name-path="name"></bs-form-select>
    </div>
    <div class="col">
      <bs-form-select label="Location age" placeholder="Please select" value.bind="model.locationCurrentnessStatus" options.bind="enums.locationCurrentnessStatuses" value-path="value" name-path="name"></bs-form-select>
    </div>
    <div class="col">
      <bs-form-select label="Zone" placeholder="Please select" value.bind="model.mapZone" options.bind="keywords.mapZones" name-path="name"></bs-form-select>
    </div>
    <div class="col">
      <bs-form-switch text="Inside zone" checked.bind="model.insideMapZone" disabled.bind="model.mapZone == null"></bs-form-switch>
    </div>
  </div>
  <div class="form-row" af-measure.bind="[{ property: 'scrollWidth', to: 460, class: 'row-cols-1' }, { property: 'scrollWidth', from: 460, to: 1120, class: 'row-cols-3' }, { property: 'scrollWidth', from: 1120, class: 'row-cols-5' }]">
    <div class="col">
      <div id="siteLocationSelectingFilterWrapper">
        <span if.bind="model.selectedLocation">
          <bs-form-input label="Site or location" placeholder="Enter name or select in map" value.bind="model.selectedLocation | latLng"></bs-form-input>
        </span>
        <span else>
          <bs-form-lookup label="Site or location" placeholder="Enter name or select in map" item.bind="model.site" options.bind="sitesLookupOptions" stick-mode="true" value-path="name" template-path="templates/site-lookup.html" maxlength="500"></bs-form-lookup>
        </span>
        <div id="locationSelectingFilterIconWrapper" click.delegate="locationSelectingIconClicked()">
          <i class="fa-regular fa-circle-dot ${isLocationSelecting ? '--isLocationSelecting' : '' }"></i>
        </div>
      </div>
    </div>
    <div class="col">
      <bs-form-input label="Distance (m)" value.bind="model.distanceFromSiteInMeters" type="number" min="1"></bs-form-input>
    </div>
  </div>
</template>
